/** What `GaiaVaultPicker` can tick: vault folders and contracts. */
export type VaultPickKind = 'directory' | 'contract';

/**
 * `vault`: browse folders and contracts, switching to contract results while a
 * search or filter is set. `contracts`: always the contract search results.
 */
export type VaultPickerScope = 'vault' | 'contracts';

/** The contract search `GaiaVaultPicker` runs. Empty text and no filters match every contract. */
export interface VaultPickerCriteria {
  text: string;
  /** Contract type names — the contract search filters on the name. */
  types: string[];
  tags: string[];
}

export function emptyVaultPickerCriteria(): VaultPickerCriteria {
  return { text: '', types: [], tags: [] };
}
